import React from 'react';
import TranslatedSpan from './translated.span';

export const TermsAndConditions = () => {
    return <>
        <p>
            <TranslatedSpan english="By logging in, you’re accessing data on a U.S. Government Information System that is owned and operated by the Centers for Medicare & Medicaid Services, the federal agency that runs Medicare."/>
        </p>
        <ul>
            <li>
                <TranslatedSpan english="Any information in this system is for use by authorized Medicare.gov users only." />
            </li>
            <li>
                <TranslatedSpan english="Your visit may be monitored, recorded, and subject to audit. We do this to protect the security of this system and data." />
            </li>
            <li>
                <TranslatedSpan english="If you access, use, or share anyone else’s information, you may face civil and criminal penalties, including disciplinary action." />
            </li>
        </ul>
    </>;
};